import { create } from 'zustand';
import type { PendingLootDTO } from '@hexcrawl/shared-utils';

interface LootState {
  pendingLoot: PendingLootDTO | null;
  setPendingLoot: (loot: PendingLootDTO | null) => void;
  clearPendingLoot: () => void;
}

export const useLootStore = create<LootState>()((set) => ({
  pendingLoot: null,
  setPendingLoot: (loot) => set({ pendingLoot: loot }),
  clearPendingLoot: () => set({ pendingLoot: null }),
}));
